export default "__VITE_ASSET__DU0lQ9xv__"